import { createTheme } from "@mui/material/styles";

export const shadows = createTheme().shadows;
